module.exports = __webpack_public_path__ + "static/media/lock.711247a9.svg";